import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { PlayCard } from './PlayCard';
interface Play {
  id: number;
  name: string;
  description: string;
  expectedMetrics: string;
  personas: string[];
  motion: string;
  stage: string;
  vertical: string;
  difficulty: 'Easy' | 'Medium' | 'Hard';
  timeToImplement: string;
  isFeatured: boolean;
  performanceBadge: string | null;
}
interface FeaturedPlaysProps {
  plays: Play[];
}
export function FeaturedPlays({
  plays
}: FeaturedPlaysProps) {
  return <div className="mb-8" data-id="element-1127">
      <div className="flex items-center gap-2 mb-4" data-id="element-1128">
        <SparklesIcon className="w-5 h-5 text-red-600" data-id="element-1129" />
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-1130">Featured Plays</h3>
        <span className="px-2 py-0.5 bg-red-100 text-red-700 text-xs font-medium rounded-full" data-id="element-1131">
          Trending
        </span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-1132">
        {plays.map(play => <PlayCard key={play.id} play={play} data-id="element-1133" />)}
      </div>
    </div>;
}